import React from "react"
import Row from 'react-bootstrap/Row'
import Image from 'react-bootstrap/Image'
import gif from '../../assets/images/comingsoon.gif'
import './style.css'

function ComingSoon() {
    return (
        <div className="comingSoon">
            <Row lg={2} md={2} className="imageCenter">
                <Image fluid src={gif} />
            </Row>
        </div>

    )
}

export default ComingSoon